var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.updateComponentKey, staticClass: "permissionsContainer" },
    [
      _c("div", { staticClass: "permissionsHeaderContainer" }, [
        _c("div", { staticClass: "labelContainer" }, [
          _c(
            "div",
            { staticClass: "searchContainer" },
            [
              _c("v-icon", [_vm._v(" search ")]),
              _vm._v(" "),
              _c("InputField", {
                attrs: {
                  inputType: "text",
                  value: _vm.search,
                  placeholder: _vm.$t("Search"),
                  inputStyle: {
                    borderRadius: "0px",
                    width: "300px",
                    border: "none",
                    padding: "0px"
                  }
                },
                on: {
                  input: function($event) {
                    return _vm.handleSearch($event)
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkBoxContentPermissions" }, [
          _c("span", { staticClass: "labelPermissionHeader" }, [
            _vm._v(_vm._s(_vm.$t("View")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkBoxContentPermissions" }, [
          _c("span", { staticClass: "labelPermissionHeader" }, [
            _vm._v(_vm._s(_vm.$t("Create")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkBoxContentPermissions" }, [
          _c("span", { staticClass: "labelPermissionHeader" }, [
            _vm._v(_vm._s(_vm.$t("Edit")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkBoxContentPermissions" }, [
          _c("span", { staticClass: "labelPermissionHeader" }, [
            _vm._v(_vm._s(_vm.$t("Delete")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "checkBoxContentPermissions",
            staticStyle: { border: "none" }
          },
          [
            _c("span", { staticClass: "labelPermissionHeader" }, [
              _vm._v(_vm._s(_vm.$tc("Other", 2)))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.data, function(permissions, index) {
        return _c(
          "div",
          { key: permissions.label },
          [
            _c(
              "div",
              { staticClass: "expantionHeaderContainer" },
              [
                _c(
                  "div",
                  {
                    staticClass: "labelContainer",
                    on: {
                      click: function($event) {
                        return _vm.expandClick(index)
                      }
                    }
                  },
                  [
                    _vm.expandOrders[index]
                      ? _c("v-icon", { staticClass: "expandIcon" }, [
                          _vm._v(
                            "\n                    expand_more\n                "
                          )
                        ])
                      : _c("v-icon", { staticClass: "expandIcon" }, [
                          _vm._v(
                            "\n                    expand_less\n                "
                          )
                        ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("permissions.types." + permissions.label))
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.columnNames, function(columnName, columnIndex) {
                  return _c(
                    "div",
                    {
                      key: columnName,
                      staticClass: "checkBoxContent",
                      class: {
                        lastCheckbox: columnIndex === _vm.checkboxes.length - 1
                      }
                    },
                    [
                      _vm.hideCheckboxHeaders &&
                      _vm.checkboxesArray.length > 0 &&
                      _vm.checkboxesArray[index][columnIndex] !== null
                        ? _c("InputField", {
                            key: _vm.updateComponentKey,
                            attrs: {
                              inputType: "checkbox",
                              value: _vm.checkboxesArray[index][columnIndex],
                              checkboxOptions: [
                                { id: "test" + (columnIndex + 1) }
                              ],
                              inputFieldContainerStyling: { padding: "2px" },
                              indeterminate: _vm.isColumnIndeterminate(
                                index,
                                columnName,
                                columnIndex
                              ),
                              "input-disabled": _vm.disabled
                            },
                            on: {
                              input: function($event) {
                                return _vm.toggleAllCheckboxes(
                                  index,
                                  columnIndex
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(permissions.items, function(item, checkboxIndex) {
              return !_vm.expandOrders[index]
                ? _c(
                    "div",
                    { key: item.label, staticClass: "expansionContent" },
                    [
                      _c("div", { staticClass: "labelContent" }, [
                        _c("span", { staticClass: "permissionsSpan" }, [
                          _vm._v(_vm._s(_vm.$t(item.label)))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.columnNames, function(
                        property,
                        propertyIndex
                      ) {
                        return _c(
                          "div",
                          {
                            key: property,
                            staticClass: "checkBoxContent",
                            class: { lastCheckbox: propertyIndex === 4 }
                          },
                          [
                            item[property] !== null
                              ? _c("InputField", {
                                  key: propertyIndex,
                                  attrs: {
                                    inputType: "checkbox",
                                    value: item[property],
                                    checkboxOptions: [
                                      { id: "test" + (propertyIndex + 1) }
                                    ],
                                    "input-disabled": _vm.disabled,
                                    inputFieldContainerStyling: {
                                      padding: "2px"
                                    }
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.handleCheckboxChange(
                                        index,
                                        checkboxIndex,
                                        property
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "expansionContentLine" },
              [
                _c("div", { staticClass: "labelContent" }),
                _vm._v(" "),
                _vm._l(_vm.checkboxes, function(checked, index) {
                  return _c("div", {
                    key: checked,
                    staticClass: "checkBoxContent",
                    class: { lastCheckbox: index === _vm.checkboxes.length - 1 }
                  })
                })
              ],
              2
            )
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c395c18c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c395c18c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Atoms/PermissionMatrix.vue
// module id = null
// module chunks = 